

    <app-assign-incident #assignComponent 
    [showActionButtons]="false" 
    [incidentId]="incidentId" 
    (onAssign)="onAssign($event)">
    ></app-assign-incident>

<div class="p-dialog-footer">
    <button type="button" pButton class="" (click)="assignComponent.assignIncident()">Assign</button>
    <button type="button" pButton class="p-button-outlined" (click)="modalRef.close('dismissed')">Close</button>
